var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"risk-badge"},[_c('span',{staticClass:"risk-badge__dot"}),_vm._v(" Historical probability · not a forecast ")])
}]

export { render, staticRenderFns }